import React, { useState } from 'react';

const ExploreValues = () => {
  const [responses, setResponses] = useState({
    mountaintop: '',
    legacy: '',
    money: '',
    admire: ''
  });

  const handleChange = (question, value) => {
    setResponses(prev => ({
      ...prev,
      [question]: value
    }));
  };

  const reflectionQuestions = [
    {
      id: 'mountaintop',
      question: 'Looking back on your life, describe a "mountaintop" experience. This is a moment when you felt the most joyful, exuberant, and on top of the world. What were you doing? Who were you with? How did you get to this point?'
    },
    {
      id: 'legacy',
      question: 'Imagine yourself at your 90th birthday. What do you want to be remembered for? What will you look back on and think– "Yes! That was worth it!"'
    },
    {
      id: 'money',
      question: 'If you were to unexpectedly inherit $50 million dollars, how would you spend the money? What would you do with your time if you no longer needed to work to earn money?'
    },
    {
      id: 'admire',
      question: 'Who are the two people in your life that you most admire? What qualities do you see in them that you aspire to?'
    }
  ];

  return (
    <section>
      <h2 className="section-title">Exploring Your Core Values</h2>
      <div className="section-card">
        <p>
          Discovering your core values requires honest self-reflection. The following questions are 
          designed to help you uncover what truly matters to you by examining your peak experiences, 
          aspirations, and influences.
        </p>
        
        <div className="reflection-questions">
          {reflectionQuestions.map((item, index) => (
            <div key={index} className="question-box">
              <h3 className="question-number">{index + 1}</h3>
              <p className="question-text">{item.question}</p>
              <textarea 
                className="response-input"
                rows="6"
                value={responses[item.id]}
                onChange={(e) => handleChange(item.id, e.target.value)}
                placeholder="Type your response here..."
              ></textarea>
            </div>
          ))}
        </div>
        
        <div className="values-insight">
          <h3>Finding Your Values</h3>
          <p>
            Review your responses and look for patterns. What themes emerge? What did your mountaintop 
            experience involve—achievement, connection, creativity? Who do you admire and why? Your 
            answers reveal what you truly value.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ExploreValues;